<script setup lang="ts">
import Collapsible from './Collapsible.vue'
import Icon from '../Icon.vue'

import type { UnifiedProduct } from '../../../composables/use-product-group'

withDefaults(defineProps<{
  unifiedProducts?: UnifiedProduct[]
}>(), {
  unifiedProducts: () => []
})

const hasOtherPartners = (product: UnifiedProduct) => {
  return product.otherPartners?.some(partner => partner.url && partner.partner)
}
</script>

<template>
  <template v-for="(product, productIndex) in unifiedProducts"
            :key="productIndex">
    <div class="bx-product__other-partners"
         data-tc="product-other-partners">
      <span v-if="hasOtherPartners(product)"
            class="bx-product__title bx-product__title--other-partners">
        Weitere Anbieter:
      </span>
      <ul :data-product-unique-id="product.uniqueId">
        <template v-for="(partner, i) in product.otherPartners">
          <li v-if="partner.url && partner.partner"
              :key="`partner-${i}`">
            <a :href="partner.url"
               target="_blank"
               :data-ga-coco-partner-position="(i + 1)"
               data-tc="product-other-partner-url">
              <span data-tc="product-other-partner-partner">{{ partner.partner }}</span>
              <Icon name="shopping-bag" />
            </a>
          </li>
        </template>
      </ul>
    </div>
  </template>
</template>
